export enum OtherReportType {
  NO_FORM = 'NO_FORM',
  SUBCONTRACTOR_DECISIONS = 'SUBCONTRACTOR_DECISIONS',
  INFRASTRUCTURES = 'INFRASTRUCTURES',
}
